import { useSyncExternalStore } from "react";
import { IAlarm } from "../Models/IAlarm";

// Allarmi aperti, condivisi tra la finestra dell'allarme e le card della Home.
// La finestra resta aperta finche' l'allarme non e' gestito: niente riduzione, niente riapertura.

interface IOpenAlarmsState {
  // allarmi non ancora gestiti
  alarms: IAlarm[];
}

let state: IOpenAlarmsState = { alarms: [] };
const listeners = new Set<() => void>();

const emit = (next: IOpenAlarmsState) => {
  state = next;
  listeners.forEach((l) => l());
};

export const alarmSentinelId = (alarm: IAlarm): number =>
  alarm.sensor?.sentinel?.id ?? alarm.sensor?.sentinelId;

// La finestra pubblica qui gli allarmi aperti
export const setOpenAlarms = (alarms: IAlarm[]) => {
  const open = alarms.filter((x: IAlarm) => x.served !== true);
  const sameAlarms =
    open.length === state.alarms.length &&
    open.every((x: IAlarm, i: number) => state.alarms[i]?.id === x.id);
  if (sameAlarms) return;
  emit({ alarms: open });
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useOpenAlarms = (): IOpenAlarmsState =>
  useSyncExternalStore(subscribe, () => state);

// allarmi aperti di un dispositivo
export const useSentinelAlarms = (sentinelId: number) => {
  const s = useOpenAlarms();
  return { alarms: s.alarms.filter((x: IAlarm) => alarmSentinelId(x) === sentinelId) };
};
